// @flow
import type {MarkdocTagRegistration} from 'docs/markdoc';

export const Tab: MarkdocTagRegistration = {
  tag: 'tab',
  component: 'Tab',
  attributes: {
    title: {type: String, localizable: true},
    info: {type: String},
  },
};
